// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const ETocopherols = {
  productCode: " SBOVZ-E-ADTP",
  productName: "E Tocopherols",
  ingredients: "Dehulled Sunflower seed kernel, Green Tea",
  overview:"Orgavitaz-E as Tocopherols is a standardized extract blend of Organic dehulled sunflower seed oil and green tea, as core ingredients that offers 10% Food alpha d-tocopherol along with other co-nutrients. ",
  assay:"Alpha-D-Tocopherol 10 %",
  coNutrients:"Incidental nutrients include natural folate, omega fatty acids, minerals like magnesium, calcium and proteins.  Alpha Tocopherols has the greatest physiological vitamin E activity.",
  studies:" Comprehensive Stability and oxidative studies, Cell-assays for antioxidant properties, comparative studies to understand the benefits over synthetic humectant.",
  benefits:"A powerful antioxidant of the vitamin E family. Tocotrienol activates anticancer effects and effective at accumulating in cells. Effective for reducing endothelial expression of adhesion molecules, preventing the accumulation of inflammatory cells within the arterial wall. Inhibits the excessive aggregation of blood platelets much more effectively than vitamin E. Down-regulate a liver enzyme involved in cholesterol synthesis HMG-CoA reductase (not a claim). Green tea leaf catechins helps regulates translocation of proteins",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/ETocopherols/ETP-1.png",
        "images/Portfolio/OrgavitazForDeficiencies/ETocopherols/ETP-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/ETocopherols/ETP-3.png",
    "images/Portfolio/OrgavitazForDeficiencies/ETocopherols/ETP-4.png",



  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default ETocopherols;
